import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialMdcModule } from '../../../../../shared/material-mdc.module';
import { SharedModule } from '../../../../../shared/shared.module';
import { RnNoticeComponent } from '../rn-notice/rn-notice.component';

@NgModule({
  declarations: [RnNoticeComponent],
  imports: [
    CommonModule,
    MaterialMdcModule,
    SharedModule
  ],
  exports: [RnNoticeComponent]
})
export class RnNoticeModule { }